import React, { ReactElement, Suspense, lazy } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { Box } from "@mui/material";
import styles from "./styles.module.scss";


const Home = lazy(() => import("../../../routes/Home"));
const Sport = lazy(() => import("../../../routes/Sport"));
const Live = lazy(() => import("../../../routes/Live"));
const LiveCalendar = lazy(() => import("../../../routes/LiveCalendar"));
const CasinoLive = lazy(() => import("../../../routes/CasinoLive"));
const Virtual = lazy(() => import("../../../routes/Virtual"));
const Network = lazy(() => import("../../../routes/Network"));
const Profile = lazy(() => import("../../../routes/Profile"));
const Transactions = lazy(() => import("../../../routes/Transactions"));
const Betting = lazy(() => import("../../../routes/Betting"));
const Reports = lazy(() => import("../../../routes/Reports"));
const NotFound = lazy(() => import("../../../routes/NotFound"));
const Casino = lazy(() => import("../../../routes/Casino"))
const Payments = lazy(() => import("../../../routes/Payments"))
const SportV1 = lazy(() => import("../../../routes/SportV1"))

export default function Content(): ReactElement {
  const userAuth = useAppSelector((state) => state.auth.isAuth);
  return (
    <Box className={`
    ${styles.content} 
    ${process.env.REACT_APP_SKIN_VERSION === "v1" && styles.versionOneContent}
    `}
    >
      <Suspense fallback={null}>
        <Switch>
          <Route
            exact
            path="/"
            component={
              process.env.REACT_APP_EXCLUDED_ROUTES?.includes('home') ?
                process.env.REACT_APP_SKIN_VERSION === "v1" ?
                  SportV1
                  :
                  Sport
                :
                Home
            } />
          <Route
            exact
            path="/home"
            component={
              process.env.REACT_APP_EXCLUDED_ROUTES?.includes('home') ?
                process.env.REACT_APP_SKIN_VERSION === "v1" ?
                  SportV1
                  :
                  Sport
                :
                Home
            }
          />
          <Route
            path="/sport/coupon/:serial"
            render={({ match }) =>
              <Sport serial={match.params.serial} />
            }
          />
          {process.env.REACT_APP_HIDE_LIVE_SPORT !== "true" &&
            process.env.REACT_APP_SKIN_VERSION === "v1" ?
            <Route
              path="/sport"
              component={SportV1}
            />
            :
            <Route
              path="/sport"
              component={Sport}
            />
          }

          {process.env.REACT_APP_HIDE_LIVE_SPORT !== "true" &&
            <Route exact path="/livebetting" component={Live} />
          }
          {process.env.REACT_APP_HIDE_LIVE_SPORT !== "true" &&
            <Route exact path="/livebetting/calendar" component={LiveCalendar} />
          }
          <Route exact path="/casino" component={Casino} />
          <Route exact path="/casinolive" component={CasinoLive} />
          <Route exact path="/virtual" component={Virtual} />
          <Route
            exact
            path="/profile"
            render={() => (userAuth ? <Profile /> : <Redirect to="/home" />)}
          />
          <Route
            exact
            path="/payments"
            render={() => (userAuth ? <Payments /> : <Redirect to="/home" />)}
          />
          <Route
            exact
            path="/network/manage"
            render={() => (userAuth ? <Network /> : <Redirect to="/home" />)}
          />
          <Route
            exact
            path="/reports/transactions"
            render={() => (userAuth ? <Transactions /> : <Redirect to="/home" />)}
          />
          <Route
            exact
            path="/reports/betting"
            render={() => (userAuth ? <Betting /> : <Redirect to="/home" />)}
          />
          <Route
            exact
            path="/wallet/revenues"
            render={() => (userAuth ? <Reports /> : <Redirect to="/home" />)}
          />
          <Route path="/:variable/:id"
            render={({ match }) => {
              return <Home params={match.params} />
            }} />
          <Route exact path="/:token" render={({ match: { params } }) => <Home params={params} />} />
          <Route path="*" component={NotFound} />
        </Switch>
      </Suspense>
    </Box>
  );
}
